module.exports = __webpack_public_path__ + "img/title.17f06218.png";